<div class="analysts-forecast">
	@let isLoadingRecs = isLoadingRecommendations();

	<div class="trends">
		@for (item of analystsForecast(); track item.key) {
			<div
				class="row"
				[tuiSkeleton]="isLoadingRecs"
			>
				<span
					class="title"
					[style.color]="leader().key === item.key ? 'var(' + item.colorVar + ')' : null"
				>
					{{ item.translatePath | translate }}
				</span>
				<div
					class="line"
					[style.--percent]="item.percent + '%'"
					[style.--color-line]="'var(' + item.colorVar + ')'"
				></div>
				<div class="count">
					<span class="value">{{ item.value }} </span>
					<span class="percent">({{ item.percent }}%)</span>
				</div>
			</div>
		}
	</div>

	<span
		class="count-analysts"
		[tuiSkeleton]="isLoadingRecs"
	>
		{{
			'analystsForecast.countAnalysts'
				| translate
					: {
							symbol: recommendations()?.meta?.symbol ?? liveTicker,
							count: totalAnalysts(),
					  }
		}}
	</span>

	<div
		class="conclusion"
		[tuiSkeleton]="isLoadingRecs"
	>
		<div class="left">
			<span class="title">{{ 'analystsForecast.conclusion' | translate }}</span>
			<span class="value"> {{ leader().translatePath | translate }}</span>
		</div>

		<div class="right">
			<img
				class="chevron"
				src="/images/icons/chevron-indicator.svg"
				alt="chevron-indicator"
			/>
			<span
				class="value"
				[style.color]="'var(' + leader().colorVar + ')'"
				>{{ leader().percent }}%</span
			>
			<div class="part-circle">
				<svg
					width="7"
					height="33"
					viewBox="0 0 7 33"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M6.66396 31.3205L1.48077 32.3246C0.50858 27.1695 -3.49242e-06 21.8507 -3.7301e-06 16.4131C-3.97549e-06 10.7993 0.542087 5.31203 1.57678 0.000884941L6.76191 0.996011C5.7886 5.98506 5.27863 11.1398 5.27863 16.4137C5.27863 21.5078 5.75441 26.4907 6.66396 31.3205Z"
						[attr.fill]="'var(' + leader().colorVar + ')'"
					/>
				</svg>
			</div>
		</div>
	</div>
</div>
